import { type ParserMap, parseAsArrayOf, parseAsString, parseAsStringEnum } from "nuqs";

export const BREAKDOWN_QUERY_KEYS = ["compareBy", "compareGroups"] as const;

export const BREAKDOWN_QUERY_STATE_OPTIONS = { history: "replace" as const, clearOnDefault: true, shallow: false };

const NO_GROUP_KEYS: string[] = [];

export function createBreakdownQuerySchema<TDimension extends string>(dimensions: readonly TDimension[]) {
    return {
        compareBy: parseAsStringEnum<TDimension>([...dimensions]),
        compareGroups: parseAsArrayOf(parseAsString).withDefault(NO_GROUP_KEYS)
    } satisfies Record<(typeof BREAKDOWN_QUERY_KEYS)[number], ParserMap[string]>;
}

export function toBreakdownQuery<TDimension extends string>(dimension: TDimension, groupKeys: string[]) {
    return { compareBy: groupKeys.length > 0 ? dimension : null, compareGroups: groupKeys.length > 0 ? groupKeys : null };
}
